/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeviceTypeRequest
 */
export interface DeviceTypeRequest {
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeRequest
     */
    hardwareId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeRequest
     */
    usageId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeRequest
     */
    deviceName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeRequest
     */
    rescueName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeRequest
     */
    scopeId?: string;
}

export function DeviceTypeRequestFromJSON(json: any): DeviceTypeRequest {
    return DeviceTypeRequestFromJSONTyped(json, false);
}

export function DeviceTypeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceTypeRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hardwareId': !exists(json, 'hardwareId') ? undefined : json['hardwareId'],
        'usageId': !exists(json, 'usageId') ? undefined : json['usageId'],
        'deviceName': !exists(json, 'deviceName') ? undefined : json['deviceName'],
        'rescueName': !exists(json, 'rescueName') ? undefined : json['rescueName'],
        'scopeId': !exists(json, 'scopeId') ? undefined : json['scopeId'],
    };
}

export function DeviceTypeRequestToJSON(value?: DeviceTypeRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'hardwareId': value.hardwareId,
        'usageId': value.usageId,
        'deviceName': value.deviceName,
        'rescueName': value.rescueName,
        'scopeId': value.scopeId,
    };
}

